/**
 * ConversationTranscript — the conversation-id door to a run's transcript.
 * One request returns the whole thread, any span (TRA-1089).
 */

import { getApiErrorStatus } from '@/api/client'
import { useGetConversationApiTracesConversationsConversationIdGet } from '@/api/generated/traces/traces'

import { TrajectoryTranscript } from './TrajectoryTranscript'
import { transcriptLoadError } from './transcriptLoadError'

interface ConversationTranscriptProps {
  conversationId: string
}

export function ConversationTranscript({
  conversationId,
}: ConversationTranscriptProps): React.JSX.Element {
  const query = useGetConversationApiTracesConversationsConversationIdGet(conversationId)
  const data = query.data
  const arrived = data?.status === 200
  return (
    <TrajectoryTranscript
      idLabel="Conversation"
      idValue={conversationId}
      docs={arrived ? data.data : null}
      loadError={transcriptLoadError(
        query.isError || (data !== undefined && !arrived),
        getApiErrorStatus(query.error),
      )}
    />
  )
}
